import React from 'react';
import { observer } from 'mobx-react';
import { DragDropList } from '../../../../../../global/drag-drop-list/drag-drop-list';
import { TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { TConnectionItemDraggable } from './types';
import { ConnectionTemplateConnectionGroupConnectionsListItem } from './connection-template-connection-group-connections-list-item';

export type ConnectionTemplateConnectionGroupConnectionsListProps = {
    enabledConnections: TConnection[];
    disabledConnections: TConnection[];
    enableConnection: (index: number) => void;
    disableConnection: (index: number) => void;
    onReorder: (connections: TConnection[]) => void;
    maxEnabledConnections: number;
};

export const ConnectionTemplateConnectionGroupConnectionsList = observer((props: ConnectionTemplateConnectionGroupConnectionsListProps) => {
    const { disabledConnections, enabledConnections, enableConnection, disableConnection, onReorder, maxEnabledConnections } = props;

    const mapConnectionsToDraggableItems = (data: TConnection[]): TConnectionItemDraggable[] => {
        return data.map(connection => ({ id: connection.connectionId, ...connection }));
    };

    const mapDraggableItemsToConnections = (data: TConnectionItemDraggable[]): TConnection[] => {
        return data.map(connection => {
            delete connection.id;
            return connection;
        });
    };

    const handleReorder = (data: TConnectionItemDraggable[]): void => {
        onReorder(mapDraggableItemsToConnections(data));
    };

    const toggleInactive = enabledConnections.length >= maxEnabledConnections;

    return (
        <div className='connection-group-form__connections-list'>
            <DragDropList
                numbered={true}
                data={mapConnectionsToDraggableItems(enabledConnections)}
                renderItem={(item, index) => (
                    <ConnectionTemplateConnectionGroupConnectionsListItem
                        index={index}
                        enabled={true}
                        item={item}
                        toggle={disableConnection}
                    />
                )}
                onDragEnd={handleReorder}
            />
            <div className='connection-group-form__connections-list--disabled'>
                {mapConnectionsToDraggableItems(disabledConnections).map((item, idx) => (
                    <ConnectionTemplateConnectionGroupConnectionsListItem
                        key={idx}
                        index={idx}
                        enabled={false}
                        item={item}
                        toggle={enableConnection}
                        inactive={toggleInactive}
                    />
                ))}
            </div>
        </div>
    );
});
